/* eslint-disable */
export default {
  carton_sixregular: "carton_sixregular",
  bpreplaybold: "bpreplaybold"
}